// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Library Imports
import { Form, Input } from "antd";

// Local Imports
import Label from "../../components/label/label.component";
import TestingEnvLabel from "src/components/testign-env-label.component";
import { useLocation, useParams } from "react-router-dom";
import LoginService from "../login/login-service";

const SetNewPassword: React.FC = (): ReactElement => {
  const loginService = new LoginService();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submitForm, setSubmitForm] = useState<boolean>(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitForm(true);
      },
      () => {
        setSubmitForm(false);
      }
    );
  }, [values]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-no-repeat bg-cover bg-bottom p-3 md:p-5 box-border bg-[login-background]">
      <div className="flex flex-col rounded-[20px] p-5 md:p-10 w-full md:w-[526px] bg-white box-border">
        <div className="flex items-center justify-center">
          <TestingEnvLabel classes="mb-5" />
        </div>
        <h4 className=" text-lg md:text-3xl text-blue-400 font-semibold">
          Set New Password
        </h4>
        <p className=" text-sm md:text-base text-gray-200 mt-2">
          Welcome to your Kamco account
        </p>
        <Form
          form={form}
          onFinish={(values: any) =>
            loginService.setNewPassword({ ...values, token })
          }
          initialValues={{ password: null, confirm_password: null }}
          name="login-form"
          className="mt-5"
          layout="vertical"
        >
          <div className="flex flex-col w-full">
            <Label text="Password" />
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please enter password",
                },
              ]}
            >
              <Input.Password
                className="input-field-container"
                type="password"
                placeholder="Enter Password"
                autoComplete="new-password"
              />
            </Form.Item>
          </div>
          <div className="flex flex-col w-full">
            <Label text="Confirm password" />
            <Form.Item
              name="confirm_password"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please enter confirm password",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The new password that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password
                className="input-field-container"
                type="password"
                placeholder="Enter Confirm Password"
                autoComplete="new-password"
              />
            </Form.Item>
          </div>
          <Form.Item className="mb-0">
            <button
              className="flex cursor-pointer w-full items-center hover:text-white justify-center mt-4 border-0 shadow-none text-white bg-blue-500 h-[57px] text-lg rounded-lg font-semibold disabled:text-white disabled:bg-blue-100"
              disabled={!submitForm}
            >
              Submit
            </button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SetNewPassword;
